module.exports = __webpack_public_path__ + "img/C4.8d188b1e.png";